import React from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import { colorBlue600 } from '@amzn/meridian-tokens/base/color';

/**
 * EOS Wash panel for one shift (v6): a dark header bar (white title) over a
 * single read-only note in a bordered gray box, rendered as inert (greyed)
 * text (no markup execution). The header uses the mock's navy
 * `.eos-wash-header` via a Meridian blue token.
 *
 * An optional `byline` (e.g. authored-by / last-updated) renders under the note.
 */
export interface EosWashProps {
  title: string;
  text: string;
  /** Optional attribution line shown beneath the note (e.g. "Last updated by alice • ..."). */
  byline?: string;
  testId?: string;
}

const EosWash: React.FC<EosWashProps> = ({ title, text, byline, testId }) => (
  <Box type="outline" spacingInset="none" data-testid={testId}>
    <Box backgroundColor={colorBlue600} spacingInset="300 400">
      <Text type="h100" color="inverted">
        {title}
      </Text>
    </Box>
    <Box spacingInset="400">
      <Column spacing="200">
        <Box type="outline" spacingInset="400">
          <Text type="b200" color="secondary">
            {text}
          </Text>
        </Box>
        {byline && (
          <Text type="b100" color="secondary" data-testid={testId ? `${testId}-byline` : undefined}>
            {byline}
          </Text>
        )}
      </Column>
    </Box>
  </Box>
);

export default EosWash;
